var map = {
	"./Efficiency.svg": "2ff2",
	"./Goal1.svg": "1b25",
	"./Goal2.svg": "14d97",
	"./Goal3.svg": "8d0e",
	"./Scalability.svg": "fd36",
	"./Value.svg": "a036",
	"./aboutus.svg": "cb7f",
	"./bottle.svg": "8d17",
	"./contactus.svg": "bd52",
	"./emailicon.svg": "220c",
	"./facebookicon.svg": "9815",
	"./faxicon.svg": "3cae",
	"./howitworks.svg": "62f1",
	"./more left.svg": "5cc8",
	"./more right.svg": "5db7",
	"./phoneicon.svg": "a171",
	"./service.svg": "a58a",
	"./step1.svg": "20ef",
	"./step2.svg": "d18c",
	"./step3.svg": "b1cd",
	"./twittericon.svg": "54f3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e5f";